module.exports = __webpack_public_path__ + "resources/img/img_coolfilter2_m.fc4cb8a503fa78523318286d51da3889.png";